import { render } from "./files-sidebar.vue?vue&type=template&id=8614f78a"
import script from "./files-sidebar.vue?vue&type=script&lang=js"
export * from "./files-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__